module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/lodi.65896ebbcf3e2d803f1ad936034346d8.jpg";